export default __webpack_public_path__ + "static/oliver_logo_normal-6f9d368e26472818143178e93aca00eb.svg";